import { SocieteLinkedModel } from './../../models/societe-linked/societe-linked.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from 'src/app/shared/constants/api-constants';
import { GenericCrudService } from '../basic/generic.crud.service';
import { HostnameService } from '../basic/hostname.service';
import { ReferentielDTO } from '../../dtos/referentielDTO';
import { SimpleQueryResponse } from '../../dtos/simpleQueryResponse';
import { GenericLibelleService } from '../basic/generic-libelle.service';

@Injectable()
export abstract class SocieteLinkedService<T> extends GenericLibelleService<T> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected route: string,
              protected hostnameService: HostnameService) {
              super(http, toastrService, route, hostnameService);
  }
  
  getFromSociete(idSoc: any): Observable<T[]> {
    return this.http.get<SocieteLinkedModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetFromSociete/' + idSoc)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

 // Get all fournisseurs active : dDesactivation > date du jour
 getAllActive(idSoc: any): Observable<T[]> {
    return this.http.get<SocieteLinkedModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllActive/' + idSoc)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }


  getAllFiltred(value: string, idSoc: number): Observable<T[]> {
    let param = new HttpParams();
    param = param.append('value', value);
    param = param.append('idSoc', idSoc ? idSoc.toString() : null);
    return this.http.get<SocieteLinkedModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllFiltred', {params: param})
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getFromCodeAndSociete(code: string, idSoc: number): Observable<SocieteLinkedModel> {
    return this.http.get<SocieteLinkedModel>
      (APICONSTANTS.URLAPI.value + this.route + 'getFromCodeAndSociete?code=' + code + '&idSoc=' + idSoc)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  loadFromSimpleQueryAdmin(objet: ReferentielDTO): Observable<SimpleQueryResponse<T>> {
    return this.http.post<SimpleQueryResponse<T>>(APICONSTANTS.URLAPI.value + this.route + 'loadFromSimpleQueryAdmin', objet)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }
}
